import React, { useState } from 'react'
import get from 'lodash/get'
import formatTime from 'lib/format-time'

import ImageGrid from 'Components/ugc/imageGrid'
import ImageViewer from 'Components/ugc/imageViewer'
import applyHttpsImage from 'lib/apply-https-img'
import { stubArray } from 'lodash'
import canUseWebp from 'lib/can-use-webp'
interface IProps {
  content: string
  image_urls: any[]
  title: string
}

function handleContent(content: string): string {
  return content.replace(/\{!--.*?--\}/g, '')
}

export default function Content({ image_urls, content, title }: IProps) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [viewing, setViewing] = useState(false)
  const handleImageItemClick = (e: any) => {
    const { index } = e.target.dataset
    if (!index) return
    setActiveIndex(Number(index))
    setViewing(true)
  }
  const getImageList = () => {
    if (!(image_urls && image_urls.length)) return null
    if (viewing)
      return (
        <div className="image-viewer-wrapper">
          <ImageViewer
            imgList={image_urls.map((e) => applyHttpsImage(e.url))}
            activeIndex={activeIndex}
            onClick={() => {
              setViewing(false)
            }}
          />
          <style jsx>
            {`
              .image-viewer-wrapper {
                margin-top: 20px;
              }
            `}
          </style>
        </div>
      )
    return (
      <ImageGrid
        list={image_urls}
        handleImageItemClick={handleImageItemClick}
      />
    )
  }
  return (
    <article>
      <div
        className="article"
        ref={(node) => {
          if (!node) {
            return
          }
          if (!canUseWebp) {
            const imgEles = node.querySelectorAll('img')
            for (const imgELe of imgEles) {
              imgELe.src = imgELe.src.replace(/\.webp$/, '.png')
            }
          }
        }}
      >
        <article className="content">{title}</article>
        {content && (
          <article
            id="article"
            className="article-content"
            dangerouslySetInnerHTML={{
              __html: handleContent(content),
            }}
          />
        )}
        {!content && getImageList()}
      </div>
      <style jsx>
        {`
          article {
            font-size: 16px;
            line-height: 28px;
            color: #1a1a1a;
          }
          .content {
            white-space: pre-wrap;
          }
          :global(.article-content p, .article-content h1) {
            line-height: 1.75;
            margin-top: 20px;
            font-size: 16px;
          }
          :global(.article-content img) {
            width: 100%;
            height: 100%;
            margin: 20px auto;
            display: block;
          }
        `}
      </style>
    </article>
  )
}
